<template>
  <div class="generate">

    <el-card class="box-card">
      <h2> {{header}} </h2>
      <el-form ref="newUserForm" label-position="left" :model="newUserForm" :rules="genRules" label-width="150px"
               style="margin-left: 15%; margin-right: 15%; text-align:left">
        <el-form-item label="Login Name" prop="login_name">
          <el-input v-model="newUserForm.login_name" :disabled="disableLoginName"></el-input>
        </el-form-item>
        <el-form-item label="User Type" prop="user_type">
          <el-radio v-model="newUserForm.user_type" :label="1">System Admin</el-radio>
          <el-radio v-model="newUserForm.user_type" :label="2">Admin</el-radio>
        </el-form-item>
        <el-form-item label="User Password" prop="user_pwd">
          <el-input type="password" required autocomplete="off" v-model="newUserForm.user_pwd" show-password></el-input>
        </el-form-item>
        <el-form-item label="Re-type Password" prop="checkPass">
          <el-input type="password" required autocomplete="off" v-model="newUserForm.checkPass"></el-input>
        </el-form-item>
        <el-form-item label="Name" prop="name">
          <el-input v-model="newUserForm.name"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input type="email" placeholder="Email Address" v-model="newUserForm.email" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" plain @click="onSubmit()" :loading="generating">Submit</el-button>
          <el-button type="info" plain @click="$router.go(-1)">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {addUser, modifyUser} from '../api'
import moment from 'moment'
export default {
  name: 'UserForm',
  data () {
    var validatePassMatch = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please Enter Password Again'))
      } else if (value !== this.newUserForm.user_pwd) {
        callback(new Error('The Value Does not Match with Password'))
      } else {
        callback()
      }
    }
    return {
      generating: false,
      disableLoginName: false,
      action: 'Undefined',
      header: '',
      newUserForm: {
        login_name: '',
        user_type: 1,
        user_pwd: '',
        name: '',
        email: '',
        checkPass: ''
      },
      genRules: {
        login_name: [
          { required: true, message: 'Please Enter Login Name', trigger: 'blur' }
        ],
        user_type: [
          { required: true, message: 'Please Select a User Type', trigger: 'blur' }
        ],
        user_pwd: [
          { required: true, message: 'Please Enter User Password', trigger: 'blur' }
        ],
        email: [
          { type: 'email', required: true, message: 'Please Enter a Valid Email', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'Please Enter Customer Name', trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePassMatch, trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount: function () {
    this.generating = false
  },
  created: function () {
    this.action = this.$route.params.action ? this.$route.params.action : 'add'
    this.header = this.action === 'add' ? 'Add User' : 'Modify User'
    if (this.action === 'modify') {
      this.newUserForm.login_name = this.$route.params.data ? this.$route.params.data.login_name : ''
      this.newUserForm.user_type = this.$route.params.data ? this.$route.params.data.user_type : 1
      this.newUserForm.name = this.$route.params.data ? this.$route.params.data.name : ''
      this.newUserForm.email = this.$route.params.data ? this.$route.params.data.email : ''
    }
    this.disableLoginName = this.action === 'modify'
  },
  methods: {
    onSubmit () {
      const that = this
      that.$refs.newUserForm.validate((valid) => {
        if (valid) {
          that.generating = true

          // delete type checkPass
          that.$delete(that.newUserForm, 'checkPass')

          if (that.action === 'add') {
            addUser(that.newUserForm).then(data => {
              that.generating = false
              console.log('addUser Success -> data')
              console.log(data)
              that.$router.push({name: 'UserList'})
            }).catch(error => {
              if (error) {
                console.log(error.stack)
              }
              that.generating = false
            })
          } else if (that.action === 'modify') {
            modifyUser(that.newUserForm).then(data => {
              that.generating = false
              console.log('modifyUser Success -> data')
              console.log(data)
              that.$router.push({name: 'UserList'})
            }).catch(error => {
              if (error) {
                console.log(error.stack)
              }
              that.generating = false
            })
          }
        }
      })
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD HH:mm:ss ZZ', true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .generate{
    margin: 0px auto;
    position: relative;
    margin-top: 50px;
  }
  .changed {
    background-color: orange;
    color: white;
  }
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// UserForm.vue?2b02dc42